import { FirebaseService } from 'src/app/services/firebase.service';
import { AuthService } from './../../services/auth.service';
import { GlobalService } from 'src/app/services/global.service';
import { Notiz } from './../../../../sharedTypes/notiz';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EditNotizComponent } from '../edit-notiz/edit-notiz.component';

@Component({
    selector: 'app-notiz',
    templateUrl: './notiz.component.html',
    styleUrls: ['./notiz.component.scss'],
    standalone: false,
})
export class NotizComponent implements OnInit {
    @Input() notiz: Notiz = new Notiz();

    constructor(
        public glo: GlobalService,
        public authService: AuthService,
        public firebaseService: FirebaseService,
        public dialog: MatDialog,
    ) {}

    ngOnInit(): void {}

    async editNotiz() {
        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        cfg.data = { notiz: JSON.parse(JSON.stringify(this.notiz)) };
        const dialogRef = this.dialog.open(EditNotizComponent, cfg);
        await dialogRef.afterClosed().toPromise();
    }

    archivNotiz(archiv: boolean) {
        const savedNotiz = JSON.parse(JSON.stringify(this.notiz));
        this.notiz.archiv = archiv;
        this.firebaseService.updateNotiz(this.notiz, savedNotiz);
    }
}
